import { createReducer } from './reducerUtils'
import { PROJECT_LOAD } from './project'
import isEmpty from 'lodash/isEmpty'
import intersection from 'lodash/intersection'
import uniq from 'lodash/uniq'

// ACTIONS
export const USER_FILTER_SET = 'USER_FILTER_SET'
export const USER_FILTER_REMOVE = 'USER_FILTER_REMOVE'
export const UNASSIGNED_FILTER_ADD = 'UNASSIGNED_FILTER_ADD'
export const UNASSIGNED_FILTER_REMOVE = 'UNASSIGNED_FILTER_REMOVE'
export const ASSIGNED_FILTER_ADD = 'ASSIGNED_FILTER_ADD'
export const ASSIGNED_FILTER_REMOVE = 'ASSIGNED_FILTER_REMOVE'
export const FILTER_TOGGLE_ON = 'FILTER_TOGGLE_ON'
export const FILTER_TOGGLE_OFF = 'FILTER_TOGGLE_OFF'
export const FILTER_CLEAR = 'FILTER_CLEAR'

// ACTION CREATORS
export const userFilterSet = (projectId, users) => ({ type: USER_FILTER_SET, payload: { users, projectId } })
export const userFilterRemove = (projectId) => ({ type: USER_FILTER_REMOVE, payload: { projectId } })
export const unassignedFilterAdd = (projectId) => ({ type: UNASSIGNED_FILTER_ADD, payload: { projectId } })
export const unassignedFilterRemove = (projectId) => ({ type: UNASSIGNED_FILTER_REMOVE, payload: { projectId } })
export const assignedFilterAdd = (projectId) => ({ type: ASSIGNED_FILTER_ADD, payload: { projectId } })
export const assignedFilterRemove = (projectId) => ({ type: ASSIGNED_FILTER_REMOVE, payload: { projectId } })
export const filterToggleOn = (projectId) => ({ type: FILTER_TOGGLE_ON, payload: { projectId } })
export const filterToggleOff = (projectId) => ({ type: FILTER_TOGGLE_OFF, payload: { projectId } })
export const filterClear = (projectId) => ({ type: FILTER_CLEAR, payload: { projectId } })

export const ASSIGNED_FILTER_KEY = 'ASSIGNED_FITLER_KEY'
export const UNASSIGNED_FILTER_KEY = 'UNASSIGNED_FILTER_KEY'
export const USER_FILTER_KEY = 'USER_FILTER_KEY'

const NULL_FILTER = tasks => tasks
const FILTERS = {
  [UNASSIGNED_FILTER_KEY]: state => task => !task.assignments.length,
  [ASSIGNED_FILTER_KEY]: state => task => !!task.assignments.length,
  [USER_FILTER_KEY]: state => task => intersection(
    task.assignments.map(assignment => assignment.userId),
    state.filteredUsers.map(user => user.id)
  ).length
}

export const getFilter = state => state.isOn && state.filters.length
  ? tasks => {
    let filters = state.filters.map(filterKey => FILTERS[filterKey](state))
    return tasks.filter(task => filters.some(filter => filter(task)))
  }
  : NULL_FILTER

const removeFilter = (state, filterKey) => {
  let filters = state.filters.filter(key => key !== filterKey)
  return {
    ...state,
    filters: filters,
    isOn: !isEmpty(filters)
  }
}

const addFilter = (state, filterKey) => ({
  ...state,
  filters: uniq([ ...state.filters, filterKey ]),
  isOn: true
})

const userFilterSetReducer = (state, payload) => {
  let newState = addFilter(state, USER_FILTER_KEY)
  return {
    ...newState,
    filteredUsers: payload.users,
  }
}

const userFilterRemoveReducer = (state) => {
  let newState = removeFilter(state, USER_FILTER_KEY)
  return {
    ...newState,
    filteredUsers: [],
  }
}

const filterInitialState = {
  isOn: false,
  filters: [],
  filteredUsers: []
}

//Ensure that the initial state is populated for new projects
const projectLoadReducer = (state, payload) => ({
  ...state,
  [payload]: state[payload] || filterInitialState
})

const scopeToProject = reducer => {
  return (state, payload) => ({
    ...state,
    [payload.projectId]: reducer(state[payload.projectId], payload)
  })
}

const unassignedFilterAddReducer = (state) => addFilter(state, UNASSIGNED_FILTER_KEY)
const assignedFilterAddReducer = (state) => addFilter(state, ASSIGNED_FILTER_KEY)
const unassignedFilterRemoveReducer = (state) => removeFilter(state, UNASSIGNED_FILTER_KEY)
const assignedFilterRemoveReducer = (state) => removeFilter(state, ASSIGNED_FILTER_KEY)
const filterToggleOnReducer = (state) => ({ ...state, isOn: true })
const filterToggleOffReducer = (state) => ({ ...state, isOn: false })
const filterClearReducer = (state) => filterInitialState

const taskFilterHandlerMapping = {
  [USER_FILTER_SET]: scopeToProject(userFilterSetReducer),
  [USER_FILTER_REMOVE]: scopeToProject(userFilterRemoveReducer),
  [UNASSIGNED_FILTER_ADD]: scopeToProject(unassignedFilterAddReducer),
  [UNASSIGNED_FILTER_REMOVE]: scopeToProject(unassignedFilterRemoveReducer),
  [ASSIGNED_FILTER_ADD]: scopeToProject(assignedFilterAddReducer),
  [ASSIGNED_FILTER_REMOVE]: scopeToProject(assignedFilterRemoveReducer),
  [FILTER_TOGGLE_ON]: scopeToProject(filterToggleOnReducer),
  [FILTER_TOGGLE_OFF]: scopeToProject(filterToggleOffReducer),
  [FILTER_CLEAR]: scopeToProject(filterClearReducer),
  [PROJECT_LOAD]: projectLoadReducer
}

export const taskFilterReducer = createReducer({}, taskFilterHandlerMapping)
export default taskFilterReducer



// WEBPACK FOOTER //
// ./src/store/taskFilter.js